<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="text-right grid_flex pa-3">
          <v-btn x-large class="waiting_btn ml-1 mr-1" to="/stock/storage/refunproduct">
            <div class="btn_size count_all filled_orange">{{ can_return }}</div>
            <span class="btn_size">สินค้าส่งคืนรอย้ายเข้าคลังรอคืน</span>
          </v-btn>
          <v-btn x-large class="filled_btn ml-1 mr-1" to="/stock/storage/droprefun">
            <div class="btn_size count_all filled_red">{{ mouth_0 }}</div>
            <span class="btn_size">สินค้าคืนไม่ได้รอย้ายเข้าคลังทิ้ง</span>
          </v-btn>
        </div>
        <v-divider class="ma-1 ml-3 mr-3"/>
        <div class="grid_tab">
          <v-tabs grow show-arrows color="#86bc3a">
            <v-tab @click="page(1)"><v-badge color="red" :content="year_count">9-12 เดือน</v-badge></v-tab>
            <v-tab @click="page(2)"><v-badge color="red" :content="mouth_8">7-8 เดือน</v-badge></v-tab>
            <v-tab @click="page(3)"><v-badge color="red" :content="mouth_6">4-6 เดือน</v-badge></v-tab>
            <v-tab @click="page(4)"><v-badge color="red" :content="mouth_3">2-3 เดือน</v-badge></v-tab>
            <v-tab @click="page(5)"><v-badge color="red" :content="mouth_1">1 เดือน</v-badge></v-tab>
            <v-tab @click="page(6)"><v-badge color="red" :content="mouth_0">หมดอายุ</v-badge></v-tab>
          </v-tabs>
        </div>
        <v-divider class="ma-1 ml-3 mr-3"/>
        <div class="mb-n8 pa-4 justify-space-between grid_half">
          <v-card-title class="d_none">
            รายการสินค้า
          </v-card-title>
        </div>
        <div v-if="loading_table === true">
          <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          </v-sheet>
        </div>
        <div v-else>
          <v-card-title class="mb-n8 ml-6 d_mobile">
            รายการสินค้า
          </v-card-title>
          <div class="pa-4">
            <v-card-title>
              <v-text-field color="#86bc3a" v-model="search" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="expireHeaders" :items="expireList" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
              <template v-slot:item="dataDetail" class="grid_btn">
                <tr>
                  <td>{{ dataDetail.item.product_code }}</td>
                  <td>{{ dataDetail.item.product_name }}</td>
                  <td class="text-center">{{ dataDetail.item.quantity }}</td>
                  <td>{{ dataDetail.item.unit }}</td>
<!--                  <td><v-switch color="#86bc3a" @change="changeStatus(dataDetail.item.product_id, dataDetail.item.status)" v-model="dataDetail.item.status"></v-switch></td>-->
                  <td>
                    <div v-if="dataDetail.item.date_expired > 0" class="red--text">{{ dataDetail.item.date_expired }} ล็อต</div>
                    <div v-else>0 ล็อต</div>
                  </td>
                  <td class="pa-3">
                    <v-btn @click="getDetails(dataDetail.item.product_id)" class="pa-6 grad-success-bg white--text"><v-icon>mdi-magnify</v-icon> ดูรายละเอียด</v-btn>
                    <v-btn @click="getPromotion(dataDetail.item.product_id)" class="pa-6 ml-3 grad-warning-bg white--text">จัดโปรโมชั่น</v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Expire_stock",
  data() {
    return {
      title: 1,
      loading_page: false,
      loading_table: false,
      search: null,
      alert_success: false,
      can_return: 0,
      year_count: '',
      mouth_8: '',
      mouth_6: '',
      mouth_3: '',
      mouth_1: '',
      mouth_0: '',
      exp_count: 0,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      expireHeaders: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '160px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          fixed: true,
          width: '110px',
        },
        {
          text: 'หน่วย',
          value: 'unit',
          fixed: true,
          width: '110px',
        },
        // {
        //   text: 'สถานะขาย',
        //   value: 'status',
        //   sortable: false,
        //   fixed: true,
        //   width: '110px',
        // },
        {
          text: 'ใกล้หมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '140px',
        },
        {
          text: 'จัดการ',
          value: 'action',
          sortable: false,
          fixed: true,
          width: '390px',
        },
      ],
      expireList: [],
      expire_lists: [],
    }
  },
  methods: {
    getdata_return() {
      HTTP.post('/inventory/expireds/canreturn')
          .then((res) => {
            if (res.data.success === true) {
              this.can_return = res.data.count
              if (this.can_return <= 0) {
                this.can_return = '0'
              }else if (this.can_return < 10) {
                this.can_return = '0'+this.can_return
              }else if (this.can_return > 100) {
                this.can_return = '99+'
              }
            }
          })
    },
    async page(type) {
      this.title = type;
      if (type === 1) {
        this.loading_table = true
        setTimeout(() => this.loading_table = false, 500)
        this.expireList = this.expire_lists['1y']
      }
      if (type === 2) {
        this.loading_table = true
        setTimeout(() => this.loading_table = false, 500)
        this.expireList = this.expire_lists['8m']
      }
      if (type === 3) {
        this.loading_table = true
        setTimeout(() => this.loading_table = false, 500)
        this.expireList = this.expire_lists['6m']
      }
      if (type === 4) {
        this.loading_table = true
        setTimeout(() => this.loading_table = false, 500)
        this.expireList = this.expire_lists['3m']
      }
      if (type === 5) {
        this.loading_table = true
        setTimeout(() => this.loading_table = false, 500)
        this.expireList = this.expire_lists['1m']
      }
      if (type === 6) {
        this.loading_table = true
        setTimeout(() => this.loading_table = false, 500)
        this.expireList = this.expire_lists['0m']
        const count_exp_list = this.expireList.length
        this.exp_count = count_exp_list
      }
    },
    diffDate(date) {
      const value = date.split('-')
      const year = parseInt(value[0])
      return value[2]+'/'+value[1]+'/'+(year + 543);
    },
    changeStatus(product_id, status) {
      if (status == true) {
        this.status_id = 1;
      }
      else if (status == false) {
        this.status_id = 0;
      }
      this.disabled_status = true
      HTTP.post('/products/product/changestatus', {
        status: this.status_id,
        product_id: product_id
      }).then((res) => {
        if (res.data.success === true){
          this.disabled_status = false
          this.alert_success = true;
          setTimeout(() => this.alert_success = false, 3000);
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: res.data.message,
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.disabled_status = false
            this.getProduct()
          })
        }
      })
    },
    getExpire_lists() {
      this.loading_page = true
      HTTP.post('/inventory/getexplists')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.expire_lists = res.data
              this.expireList = this.expire_lists['1y']
              // 1 Year
              this.year_count = this.expire_lists['1y'].length
              if (this.year_count <= 0) {
                this.year_count = '0'
              }else if (this.year_count < 10) {
                this.year_count = '0'+this.year_count
              }else if (this.year_count > 100) {
                this.year_count = '99+'
              }
              // 8 month
              this.mouth_8 = this.expire_lists['8m'].length
              if (this.mouth_8 <= 0) {
                this.mouth_8 = '0'
              }else if (this.mouth_8 < 10) {
                this.mouth_8 = '0'+this.mouth_8
              }else if (this.mouth_8 > 100) {
                this.mouth_8 = '99+'
              }
              // 6 month
              this.mouth_6 = this.expire_lists['6m'].length
              if (this.mouth_6 <= 0) {
                this.mouth_6 = '0'
              }else if (this.mouth_6 < 10) {
                this.mouth_6 = '0'+this.mouth_6
              }else if (this.mouth_6 > 100) {
                this.mouth_6 = '99+'
              }
              // 3 month
              this.mouth_3 = this.expire_lists['3m'].length
              if (this.mouth_3 <= 0) {
                this.mouth_3 = '0'
              }else if (this.mouth_3 < 10) {
                this.mouth_3 = '0'+this.mouth_3
              }else if (this.mouth_3 > 100) {
                this.mouth_3 = '99+'
              }
              // 1 month
              this.mouth_1 = this.expire_lists['1m'].length
              if (this.mouth_1 <= 0) {
                this.mouth_1 = '0'
              }else if (this.mouth_1 < 10) {
                this.mouth_1 = '0'+this.mouth_1
              }else if (this.mouth_1 > 100) {
                this.mouth_1 = '99+'
              }
              // expire
              this.mouth_0 = this.expire_lists['0m'].length
              if (this.mouth_0 <= 0) {
                this.mouth_0 = '0'
              }else if (this.mouth_0 < 10) {
                this.mouth_0 = '0'+this.mouth_0
              }else if (this.mouth_0 > 100) {
                this.mouth_0 = '99+'
              }
            }
          })
    },
    getDetails(id) {
      this.$router.push('/stock/storage/expiredetail/' + id + '/' + this.title)
    },
    getPromotion(id) {
      this.$router.push('/stock/storage/expirepromotion/' + id + '/' + this.title)
    }
  },
  mounted() {
    this.getdata_return()
    this.getExpire_lists()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.d_mobile {
  display: none;
}
.grid_tab {
  display: grid;
  grid-template-columns: 100%;
  padding: 15px;
}
.count_all{
  border: 3px solid;
  border-radius: 20px;
  padding: 5px;
  margin-right: 5px;
}
.filled_btn {
  border: 2px solid red;
  color: red;
  background-color: white !important;
}
.filled_red {
  background-color: red;
  border: 2px solid red;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
}
.waiting_btn {
  border: 2px solid #ffa44d;
  color: #ffa44d;
  background-color: white !important;
}
.btn_size {
  font-size: 1.1vw;
}
.filled_orange {
  background-color: #ffa44d;
  border: 2px solid #ffa44d;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
}
.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
  grid-gap: 15px 0;
}
.grid_flex {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 1180px) {
  .d_none {
    display: none;
  }
  .d_mobile {
    display: grid;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .btn_size {
    font-size: 1.7vw;
  }
}
@media only screen and (max-width: 600px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
  }
  .btn_size {
    font-size: 16px;
  }
  .btn_size {
    font-size: 14px;
  }
}
</style>
